import React, { useEffect } from 'react';
import { usePrevious } from './use-previous';
export const useAutoResizable = ({ textArea, counterRef, autoHeight, maxRows, initRows, value }) => {
    const [rows, setRows] = React.useState(initRows);
    const prevRows = usePrevious(rows);
    const calculateRowsCount = React.useCallback(() => {
        if (!textArea.current || !autoHeight || !counterRef.current) {
            return;
        }
        const computedStyle = getComputedStyle(textArea.current);
        const value = textArea.current.value;
        counterRef.current.style.width = computedStyle.width;
        counterRef.current.value = value;
        if (counterRef.current.value.slice(-1) === '\n') {
            counterRef.current.value += ' ';
        }
        const innerHeight = counterRef.current.scrollHeight;
        counterRef.current.value = 'x';
        const singleRowHeight = counterRef.current.scrollHeight;
        let outerHeight = innerHeight;
        if (initRows) {
            outerHeight = Math.max(Number(initRows) * singleRowHeight, outerHeight);
        }
        if (maxRows) {
            outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        }
        outerHeight = Math.max(outerHeight, singleRowHeight);
        const rowCount = Math.ceil(outerHeight / singleRowHeight);
        if (prevRows !== rowCount) {
            setRows(rowCount);
        }
    }, [textArea, autoHeight, prevRows, maxRows, initRows, counterRef]);
    useEffect(calculateRowsCount, [textArea, calculateRowsCount, value]);
    return rows;
};
//# sourceMappingURL=use-auto-resizable.js.map